<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <a-button type="primary" icon="download" @click="handleExportXls('version')">导出</a-button>
<!--      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">-->
<!--        <a-button type="primary" icon="import">导入</a-button>-->
<!--      </a-upload>-->
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <version-modal ref="modalForm" @ok="modalFormOk"></version-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import VersionModal from './VersionModal'

  export default {
    name: 'VersionList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      VersionModal
    },
    data () {
      return {
        description: 'version管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'平台类别',
            align:"center",
            dataIndex: 'type',
            customRender:function (res) {
              var type = "";
              if(res == 1){
                type = "安卓";
              }else if(res == 2){
                type = "苹果";
              }
              return type;
            }
          },
          {
            title:'版本名称',
            align:"center",
            dataIndex: 'name'
          },
          {
            title:'版本号',
            align:"center",
            dataIndex: 'number'
          },
          {
            title:'版本更新内容',
            align:"center",
            dataIndex: 'content'
          },
          {
            title:'更新链接：vivo',
            align:"center",
            dataIndex: 'urlVivo'
          },
          {
            title:'更新链接：oppo',
            align:"center",
            dataIndex: 'urlOppo'
          },
          {
            title:'更新链接：mi',
            align:"center",
            dataIndex: 'urlMi'
          },
          {
            title:'更新链接：huawei',
            align:"center",
            dataIndex: 'urlHuawei'
          },
          {
            title:'更新链接：samsung',
            align:"center",
            dataIndex: 'urlSamsung'
          },
          {
            title:'更新链接：meizu',
            align:"center",
            dataIndex: 'urlMeizu'
          },
          {
            title:'更新链接：apple',
            align:"center",
            dataIndex: 'urlApple'
          },
          {
            title:'强制升级',
            align:"center",
            dataIndex: 'upgrade',
            customRender:function (res) {
              var upgrade = "";
              if(res == 0){
                upgrade = "否";
              }else if(res == 1){
                upgrade = "是";
              }
              return upgrade;
            }
          },
          {
            title:'屏蔽隐藏',
            align:"center",
            dataIndex: 'shield',
            customRender:function (res) {
              var shield = "";
              if(res == 0){
                shield = "否";
              }else if(res == 1){
                shield = "是";
              }
              return shield;
            }
          },
          {
            title:'是否支付',
            align:"center",
            dataIndex: 'pay',
            customRender:function (res) {
              var pay = "";
              if(res == 0){
                pay = "否";
              }else if(res == 1){
                pay = "是";
              }
              return pay;
            }
          },
          {
            title:'创建时间',
            align:"center",
            dataIndex: 'createTime',
            customRender:function (text) {
              return !text?"":(text.length>10?text.substr(0,10):text)
            }
          },
          {
            title:'修改时间',
            align:"center",
            dataIndex: 'updateTime',
            customRender:function (text) {
              return !text?"":(text.length>10?text.substr(0,10):text)
            }
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/version/version/list",
          delete: "/version/version/delete",
          deleteBatch: "/version/version/deleteBatch",
          exportXlsUrl: "/version/version/exportXls",
          importExcelUrl: "version/version/importExcel",
          
        },
        dictOptions:{},
      }
    },
    created() {
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      initDictConfig(){
      }


    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>